import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import AdminPage from '../../admin/shared/AdminPage'
import OpalTile from '../../../opal/OpalTile'
import FlexRow from '../../../molecules/FlexRow'

function IntegratorHome ({ root }) {
  return (
    <AdminPage>
      <FlexRow className='items-center justify-center' style={{ flexWrap: 'wrap' }}>
        <Link to={`${root}/integrator/connections`}>
          <OpalTile size='xl' className='opal-selectable font-size-lg'>
            Connections
          </OpalTile>
        </Link>
        <Link to={`${root}/integrator/domains`}>
          <OpalTile size='xl' className='opal-selectable font-size-lg'>
            Domains
          </OpalTile>
        </Link>
        <Link to={`${root}/integrator/jobs`}>
          <OpalTile size='xl' className='opal-selectable font-size-lg'>
            Jobs
          </OpalTile>
        </Link>
        <Link to={`${root}/integrator/batches`}>
          <OpalTile size='xl' className='opal-selectable font-size-lg'>
            Batches
          </OpalTile>
        </Link>
      </FlexRow>
    </AdminPage>
  )
}

IntegratorHome.propTypes = {
  root: PropTypes.any
}

export default IntegratorHome
